import CommonModal from "components/Common/CommonModal";
import SelectInput from "components/SelectInput";
import { SCALE } from "constants";
import { getScssProperty } from "helpers/style";
import React from "react";

const TypescaleModal = ({
  isTypeScaleModalOpen,
  onScaleCancel,
  title,
  onScaleApply,
  selectedScale,
  handleScaleChange,
  selectedBodySize,
  handleBodySizeChange,
  fontSizeVariables,
  data,
  designSystem,
}) => {
  return (
    <CommonModal
      isOpen={isTypeScaleModalOpen}
      onRequestClose={onScaleCancel}
      title={title}
      onApply={onScaleApply}
      onCancelText="Cancel"
      onApplyText="Apply"
      // variant="modal-secondary"
    >
      <div className="plt-modal-body-content">
        <div className="plt-select-scale-wrapper w-100 d-flex align-items-center">
          <div className="plt-dropdown-secondary">
            <div className="plt-select-dropdown-wrapper d-flex align-items-center justify-content-between">
              <div className="plt-dropdown-wrapper">
                <SelectInput
                  name="scale"
                  options={SCALE}
                  selectedOption={selectedScale}
                  defaultValue={selectedScale}
                  onSelect={handleScaleChange}
                />
              </div>
            </div>
          </div>
          {/* <div className="plt-dropdown-secondary">
            <div className="plt-select-dropdown-wrapper d-flex align-items-center justify-content-between">
              <div className="plt-dropdown-wrapper plt-dropdown-wrapper-commonsize">
                <SelectInput
                  name="fontSize"
                  options={BODY_SIZE}
                  defaultValue={selectedBodySize}
                  selectedOption={selectedBodySize}
                  onSelect={handleBodySizeChange}
                />
              </div>
            </div>
          </div> */}

          <div className="input-container dis-mr-24">
            <input
              type="number"
              value={selectedBodySize?.value}
              onChange={(e) => handleBodySizeChange(e.target.value)}
              className="input-field input-field-custom"
            />
            <span className="input-suffix">px</span>
          </div>
        </div>
        <div className="plt-preview-group">
          {fontSizeVariables.map((item, index) => (
            <div className="plt-preview" key={index}>
              <div
                className={`plt-font-preview ${item.className}`}
                style={{
                  fontFamily: data?.fontFamilies?.find(
                    (fontFamily) => fontFamily.key === "core.fontFamily.primary"
                  )?.value,
                }}
              >
                Heading over two or three lines
              </div>
              <span className="d-flex justify-content-end align-item-end">
                {getScssProperty(item.fontSizeToken)}
                {/* {getValueByPath(designSystem, item.fontSizeKey)?.value} */}
              </span>
            </div>
          ))}
        </div>
      </div>
    </CommonModal>
  );
};

export default TypescaleModal;
